import cn from "classnames"

import style from "modules/SelectionOfPsychologists/components/Card/Price/price.module.scss"
import { Psychologist } from "utils/interfaces"
import { PriceAndDiscount } from "components/Price/PriceAndDiscount"

interface Props {
    psy: Psychologist
    hasBorderTop?: boolean
}

export const Price = ({ psy, hasBorderTop = true }: Props) => {
    return (
        <div className={cn(style.container, { [style.noBorderTop]: !hasBorderTop })}>
            <div className={style.content}>
                <PriceAndDiscount psy={psy} />
            </div>
        </div>
    )
}
